import React from 'react';

import { DetailPageLayout } from 'src/components/common';
import { PeoSettingsForm } from 'src/components/peo';
import { TableDataProvider } from 'src/providers/TableDataProvider';

export const PeoDetailSettingsPage: React.FC = () => {
  return (
    <DetailPageLayout titleContent="Settings">
      <TableDataProvider>
        <PeoSettingsForm />
      </TableDataProvider>
    </DetailPageLayout>
  );
};
